module.exports = __webpack_public_path__ + "1852062a492705bdd1ebac33836ba513.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/EG.svg
// module id = C3h+
// module chunks = 0